module.exports = __webpack_public_path__ + "static/fonts/SCDream4.1719a61.woff";